import { Component, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { GridComponent } from '@progress/kendo-angular-grid';
import { groupBy } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowActionModel, WorkflowActionCartOutputModel } from 'src/app/ViewModel/WorkflowActionModel';
import { WftActionDialogComponent } from '../wft-action-dialog/wft-action-dialog.component';


const createFormGroup = (dataItem: { workflow_Id: number; task_Id: number; action_Id: number; action_Description: string; next_Step_Id: number; status_Id: number; statusDescription: string; enable_Tag: boolean; is_Default: boolean; is_Active: boolean; Document_CategoryList: any; }) => new FormGroup({
	"workflow_Id": new FormControl(dataItem.workflow_Id), // ui maintain
	"task_Id": new FormControl(dataItem.task_Id), // ui maintain
	"action_Id": new FormControl(dataItem.action_Id), // cart
	"action_Description": new FormControl(dataItem.action_Description), // cart
	"next_Step_Id": new FormControl(dataItem.next_Step_Id), // text
	"status_Id": new FormControl(dataItem.status_Id), // eip dd id
	"statusDescription": new FormControl(dataItem.statusDescription), // eip dd description
	"enable_Tag": new FormControl(dataItem.enable_Tag), // switch
	"is_Default": new FormControl(dataItem.is_Default), // switch
	"is_Active": new FormControl(dataItem.is_Active), // switch
	"Document_CategoryList": new FormControl(dataItem.Document_CategoryList), // text
});

@Component({
	selector: 'app-wft-action-kendo-dialog',
	templateUrl: './wft-action-kendo-dialog.component.html',
	styleUrls: ['./wft-action-kendo-dialog.component.css']
})
export class WftActionKendoDialogComponent implements OnInit {

	/** Send cart value to parent component, on cart dialog close */
	@Output() getActionCartValue = new EventEmitter();
	@Input() TemplateDetails: any;
	@ViewChild(GridComponent)

	private grid!: GridComponent;

	kendoData: WorkflowActionModel[] = [];
	actionCartOutputData!: WorkflowActionCartOutputModel | null;

	enableFilter = false;
	enableFullscreen = false;
	isNewRow = false;
	isNew = false;
	is_ApprovalValue!: boolean;
	selected_TypeCategory!: any[];
	editedRowIndex: number | undefined;
	formGroup!: FormGroup;
	is_Approval_Status: any;
	actionKendoList!: WorkflowActionModel[];
	public documentCategoryList: any;
	public isShow: boolean = false;
	public document_categorylist!: string | null;
	actionStatusList: RoleFeatureModel[] = [];
	bottomKendoList: any = [];

	constructor(
		private dialog: MatDialog,
		public notificationService: NotificationService,
		private _projService: ProjectInfoService,
		public commonService: CommonService,
		public workflowTemplateService: WorkflowTemplateService,
	) { }

	ngOnInit() {
		this.getWorkflowStatusList();
		this.workflowTemplateService.supportForClearInputData.subscribe(data => {
			if (data) {
				this.actionKendoList = [];
				this.sendDataBack([]);
				this.actionCartOutputData = null;
			}
		});
		this.workflowTemplateService.supportForBottomKendo.subscribe(data => {
			if (data && data.length) {
				this.bottomKendoList = data;
				this.workflowTemplateService.selectedTaskId = data.length + 1;
			} else {
				this.bottomKendoList = [];
				this.workflowTemplateService.selectedTaskId = 1;
			}
		})
		this.getcategoryValue()
	}

	setCartDataFromParent(parentAction: WorkflowActionCartOutputModel) {

	}

	getWorkflowStatusList() {
		let groupId = this.commonService.getLoggedInUserGroupId();
		/* Date :- 05-08-2023 chnaged by pradeep k null has been changed to group id*/
		this.workflowTemplateService.getWorkflowTaskList((!!this.TemplateDetails && !!this.TemplateDetails['SrcBG'] ? this.TemplateDetails['SrcBG'] : null), Module.Workflow, "Workflow", null, "Workflow Action Status", null, null, (!!this.TemplateDetails && !!this.TemplateDetails['SrcProject'] ? this.TemplateDetails['SrcProject'] : null)).subscribe(data => {
			this.actionStatusList = data;
		});
	}

	changeWorkflowStatus(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.formGroup.get('status_Id')?.setValue(event.value);
			this.formGroup.get('statusDescription')?.setValue(event.text);
		} else {
			this.formGroup.get('status_Id')?.setValue(null);
			this.formGroup.get('statusDescription')?.setValue('');
		}
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}

	cancelRowData(event: any) {
		this.closeEditor();
	}

	editRowData(event: any) {
		this.selected_TypeCategory = [];
		if (this.editedRowIndex && this.editedRowIndex >= 0) {
			event.sender.closeRow(this.editedRowIndex);
		}
		this.formGroup = createFormGroup(event.dataItem);
		this.editedRowIndex = event.rowIndex;
		this.isNewRow = false;
		this.grid.editRow(event.rowIndex, this.formGroup);
		let selectedCategory = event.dataItem.Document_CategoryListId.split(',');
		if (!!selectedCategory) {
			selectedCategory.forEach((element: any) => {
				this.selected_TypeCategory.push(parseInt(element))
			});
		}

	}


	getApprovalValue(val: boolean) {
		this.is_ApprovalValue = val;
		this.isShow = val;
	}

	UpdateRowData(input: any) {
		if (this.formGroup.get('action_Id')?.value) {
			if (this.formGroup.get('next_Step_Id')?.value == this.workflowTemplateService.selectedTaskId) {
				this.notificationService.showToast("Next Step Id should not be equal to current Step Id", 'Warning');
				this.formGroup.get('next_Step_Id')?.setValue(0);
				return;
			}
		}

		let temp = [];

		for (let i = 0; i < this.actionKendoList.length; i++) {
			if (this.actionKendoList[i].action_Id == this.formGroup.get('action_Id')?.value) {
				temp.push(this.formGroup.value);
				if (temp.length > 0) {
					for (let j = 0; j < temp.length; j++) {
						if (i == j) {
							temp[j]["Document_CategoryList"] = this.actionKendoList[i].Document_CategoryList;
							temp[j]["Document_CategoryListId"] = this.actionKendoList[i].Document_CategoryListId;
							temp[j]["is_ApprovalValue"] = this.is_ApprovalValue;
						}
					}
				}
			} else {
				temp.push(this.actionKendoList[i]);
				for (let i = 0; i < this.actionKendoList.length; i++) {
					if (temp.length > 0) {
						for (let j = 0; j < temp.length; j++) {
							if (i == j) {
								temp[j]["Document_CategoryList"] = this.actionKendoList[i].Document_CategoryList;
								temp[j]["Document_CategoryListId"] = this.actionKendoList[i].Document_CategoryListId;
								temp[j]["is_ApprovalValue"] = this.is_ApprovalValue;
							}
						}
					}
				}
			}
		}
		this.actionKendoList = temp;
		this.setCartData();
		this.sendDataBack(this.actionKendoList);
		this.isNewRow = false;
		this.closeEditor();
	}

	public cancelHandler(): void {
		this.closeEditor();
	}

	private closeEditor(): void {
		this.grid.closeRow(this.editedRowIndex);
		this.isNew = false;
		this.editedRowIndex = undefined;
		this.formGroup = new FormGroup({});
	}

	public openActionDialog() {
		let dialogRef = this.dialog.open(WftActionDialogComponent, {
			disableClose: true,
			panelClass: 'mat-dialog-secondary',
			data: {
				'is_Approval_Status': this.is_ApprovalValue,
				'selectedEventList': (this.actionCartOutputData && this.actionCartOutputData.selectedEventList && this.actionCartOutputData.selectedEventList.length) ? this.actionCartOutputData.selectedEventList : [],
				'SelectedPrevActions': (this.actionCartOutputData && this.actionCartOutputData.data && this.actionCartOutputData.data.length > 0) ? this.actionCartOutputData.data : [],
			},
		});
		dialogRef.afterClosed().subscribe((data: WorkflowActionCartOutputModel) => {
			if (data) {
				if (data.is_Approval_Status == true) {
					this.isShow = true;
					this.getcategoryValue();
				}
				this.actionKendoList = data.data;
				this.sendDataBack(this.actionKendoList);
			}
		});
	}

	getDocument_CategoryList(): void | string {
		if (!!this.document_categorylist)
			return this.document_categorylist;
	}

	onTypeChange(event?: any, dataItem?: any) {
		this.document_categorylist = null;
		if (!!event) {
			if (event.emittingList.length > 0) {
				let selected_Category = event.emittingList.map((x: any) => x.additionalValues);
				let Select_sortValue: any[] = [];
				let SelectValueId: any[] = [];
				selected_Category.forEach((element: any) => {
					Select_sortValue.push(element.dedDescription);
					SelectValueId.push(element.dedId);
				});
				dataItem["Document_CategoryList"] = Select_sortValue.toString();
				dataItem["Document_CategoryListId"] = SelectValueId.toString()
				this.document_categorylist = Select_sortValue.toString();
			} else {
				dataItem["Document_CategoryList"] = null;
				dataItem["Document_CategoryListId"] = null;
			}
		}
	}


	getcategoryValue() {
		this._projService.getProjectElementDetails({ projectId: (!!this.TemplateDetails && !!this.TemplateDetails['SrcProject'] ? this.TemplateDetails['SrcProject'] : this.commonService.getProjectId()), groupId: (!!this.TemplateDetails && !!this.TemplateDetails['SrcBG'] ? this.TemplateDetails['SrcBG'] : this.commonService.getLoggedInUserGroupId()), moduleId: Module.ScheduleDocument, deDescription: "Document Category" })
			.subscribe((res: IProjectElementDetailsOutput[]) => {
				this.documentCategoryList = res;
			})
	}

	changeActiveStatus(event: MatCheckboxChange) {
		this.formGroup.get('is_Active')?.setValue(event.checked);
	}

	changeSupersedeStatus(event: MatCheckboxChange) {
		this.formGroup.get('enable_Tag')?.setValue(event.checked ? 1 : 0);
	}

	/**
	 * Set data from parent component
	 * @param parentKendoArr 
	 */

	setKendoDataFromParent(parentKendoArr: WorkflowActionModel[], is_Approval_Status?: any, WorkflowActionCategory?: any) {
		this.getApprovalValue(is_Approval_Status);

		if (!parentKendoArr) {
			this.actionStatusList = [];
			return;
		}
		let grpdStatusList = groupBy(this.actionStatusList, 'dedId');
		parentKendoArr.forEach((each: any) => {
			if (grpdStatusList && grpdStatusList[each.status_Id] && grpdStatusList[each.status_Id].length) {
				each.statusDescription = grpdStatusList[each.status_Id][0].dedDescription;
			}
		});
		this.actionKendoList = parentKendoArr;
		this.actionKendoList.forEach(val => {
			if (WorkflowActionCategory.length > 0) {

				WorkflowActionCategory.forEach((element: any) => {
					if (val.task_Id == element.task_Id) {

						if (val.action_Id == element.action_Id) {

							val.Document_CategoryList = element.category_Description;

							val.Document_CategoryListId = element.category_Id;

						}

					}

				});
			}
		})

		this.sendDataBack(parentKendoArr);
		this.setCartData();
	}

	/**
	 * Call only value came from parent component. 
	 */

	setCartData() {
		let temp: WorkflowActionCartOutputModel = {
			'selectedIds': [],//number
			'selectedTextWithValue': [], // { value: string | number, text: string }
			'data': [], // kendo data WorkflowActionModel
			'selectedNames': [], //string
			'selectedEventList': [], //any
		}
		this.actionKendoList.forEach(each => {
			temp.selectedIds.push(each.action_Id);
			temp.selectedTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(each.action_Id, each.action_Description));
			temp.data.push(each);
			temp.selectedNames.push(each.action_Description);
			temp.selectedEventList.push(this.workflowTemplateService.getAsCartSelectedValue(each.action_Id, each.action_Description));
		});
		this.actionCartOutputData = temp;
	}

	/**
	 * Emit data back to parent component
	 * @param actionKendoList 
	 */

	sendDataBack(actionKendoList: WorkflowActionModel[], WorkflowActionCategory?: any) {
		actionKendoList["WorkflowActionCategory"] = WorkflowActionCategory;
		this.getActionCartValue.emit(actionKendoList);
	}

	isAllActionsSaved(): boolean {
		return this.editedRowIndex == null;
	}

}